<template>
  <v-list-item>
    <v-list-item-icon>
      <v-avatar color="#def6ff" size="30" class="icon-box">
        <v-icon small color="#00B3FF">{{ icon }}</v-icon>
      </v-avatar>
    </v-list-item-icon>
    <v-row style="height: 50px;">
      <v-col cols="4" class="detail-label">{{ label }}</v-col>
      <v-col cols="8">
        <v-menu
          ref="menu"
          v-model="menu"
          :close-on-content-click="false"
          transition="scale-transition"
          offset-y
          min-width="290px"
        >
          <template v-slot:activator="{ on }">
            <v-text-field
              :solo="!editMode"
              :outlined="editMode"
              :readonly="!editMode"
              flat
              class="pt-1"
              v-on="on"
              :value="displayValue"
              @keydown="onKeyDown"
            ></v-text-field>
          </template>
          <v-date-picker
            v-model="internalValue"
            @change="save"
            :solo="!editMode"
            :outlined="editMode"
            :readonly="!editMode"
            flat
            class="pt-1"
          ></v-date-picker>
        </v-menu>
      </v-col>
    </v-row>
  </v-list-item>
</template>

<script>
export default {
  props: {
    icon: String,
    label: String,
    value: String,
    editMode: Boolean,
    selectedValue: String,
  },
  data() {
    return {
      menu: false,
      internalValue: null, // Initialize internalValue to null
    };
  },
  computed: {
    displayValue() {
      return this.internalValue;
    },
  },
  watch: {
    // Watch for changes in selectedValue prop
    selectedValue(newValue) {
      // Update internalValue when selectedValue changes
      this.internalValue = newValue;
    },
  },
  methods: {
    save(date) {
      this.$emit("changeInput", date);
      this.menu = false;
    },
    onKeyDown(event) {
      event.preventDefault();
    },
  },
};
</script>

<style scoped>
.icon-box {
  border-radius: 30%;
}

.detail-label {
  font-weight: 500;
  color: black;
}

.v-text-field {
  margin-top: -15px;
}

.v-text-field--outlined >>> fieldset {
  border-color: #00b3ff63;
}
</style>
